import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { SearchFeatureComponent } from '../../../shared/search/components/search-feature/search-feature.component';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { XButtonComponent } from '../../../shared/x-kit/components/x-button/x-button.component';
import { GTrack } from '../../../tracker';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { forkJoin, ReplaySubject, takeUntil } from 'rxjs';
import {
  XDropdownWrapperComponent
} from "../../../shared/x-kit/components/x-dropdown-wrapper/x-dropdown-wrapper.component";

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    SearchFeatureComponent,
    NgOptimizedImage,
    NgIf,
    XButtonComponent,
    TranslatePipe,
    XDropdownWrapperComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.less',
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translate(-50%, 100%)', opacity: 0 }),
        animate('1s ease', style({ transform: 'translate(-50%, 0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translate(-50%, 0)', opacity: 1 }),
        animate('0.3s ease', style({ transform: 'translate(-50%, 100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class LandingComponent implements OnInit, OnDestroy {
  @Output() closeLanding = new EventEmitter<void>();
  private destroy$ = new ReplaySubject<void>();

  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  public translate = inject(TranslateService);

  public showLanding = true;
  public searchPlaceholder = '';
  private phrases = [
    'Parcel Identification Number (NIB)',
    'Number of Certificate Right (NHS)',
    'Coordinates',
    'Places',
    'Administrative District Name',
  ];

  private typingDelay = 50; // Скорость печати (мс)
  private pauseAfterTyping = 2000; // Пауза после полного написания слова (мс)
  private pauseAfterErasing = 100; // Пауза после полного исчезновения (мс)
  private currentPhraseIndex = 0;
  private charIndex = 0;
  private intervalId: any;

  public onCloseLanding() {
    this.showLanding = false;

    setTimeout(() => {
      this.closeLanding.emit();
    }, 300);
  }

  public onFocusSearch() {
    const input = document.querySelector('#search-input-perare');

    if (!input) {
      return
    }
    input.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center'});

    // @ts-ignore
    input.focus();
  }

  ngOnInit() {
    this.startTypingEffect();
    this.buildPhrases();

    this.translate.onLangChange.subscribe(() => this.buildPhrases());
  }

  public onLangChange(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('current_lang', lang);
  }

  private buildPhrases() {
    forkJoin([
      this.translate.get('parcel_id'),
      this.translate.get('hak_id'),
      this.translate.get('lat/lon'),
      this.translate.get('place'),
      this.translate.get('administrative_disctict_name'),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe((it) => {
        this.phrases = it;
      });
  }

  private startTypingEffect(): void {
    // Фаза печати
    const typeWord = () => {
      const currentPhrase = this.phrases[this.currentPhraseIndex];

      if (this.charIndex < currentPhrase.length) {
        this.searchPlaceholder = currentPhrase.slice(0, ++this.charIndex);
        this.intervalId = setTimeout(typeWord, this.typingDelay);
      } else {
        // После завершения печати, пауза перед исчезновением
        setTimeout(() => {
          eraseWord();
        }, this.pauseAfterTyping);
      }

      this.cdr.markForCheck();
    };

    // Фаза полного исчезновения
    const eraseWord = () => {
      this.searchPlaceholder = '';
      // Пауза перед началом следующего слова
      setTimeout(() => {
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
        this.charIndex = 0;
        typeWord();
        this.cdr.markForCheck();
      }, this.pauseAfterErasing);
    };

    typeWord();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    this.destroy$.next();
    this.destroy$.complete();
  }

  public goToAuth() {
    GTrack('landing_sign-in', 'landing');
    this.router.navigate(['auth']);
  }

  public goToRegistration() {
    GTrack('landing_sign-up', 'landing');
    this.router.navigate(['auth', 'registration']);
  }

  public trackSearch() {
    GTrack('landing_search-click', 'landing');
  }
}
